/** Copyright © 2013-2023 DataYes, All Rights Reserved. */

import { createGlobalStyle } from 'styled-components';
import { tableCss, tabCss, inputCss, selectCss, modalCss, pickerCss, formWarningCss } from './antd';

export const GlobalStyle = createGlobalStyle` 
  html,
  body {
    height: 100%;
    width: 100vw;
    padding: 0;
    margin: 0;
      div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,textarea,p,blockquote,th,td,hr,button,article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section {
      margin: 0;
      padding: 0;
    }
    ul,
    ol {
      list-style: none;
    }
    em {
      font-style: normal;
    }
    button {
      outline: none;
      box-shadow: none;
      background: none;
      border: none;
    }

    ${tableCss};
    ${tabCss};
    ${inputCss};
    ${selectCss};
    ${modalCss};
    ${pickerCss};
    ${formWarningCss};
  }
`;
